import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import '@/@fake-db/db'
// import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import { VueMaskDirective } from 'v-mask'
import { i18n } from '@/plugins/i18n'
import App from './App.vue'
import './plugins/acl'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import './mixins/icemixin'

Vue.use(VueCompositionAPI)

Vue.config.productionTip = false
Vue.directive('mask', VueMaskDirective)

Vue.filter('nirDisplay', value => {
  if (!value) return ''

  // Nettoyage de la valeur (on ne garde que les caractères alphanumériques)
  const val = value.toString().toUpperCase().replace(/[^A-Z0-9]/g, '')

  // Si la valeur est trop courte pour être formatée, on la renvoie telle quelle
  if (val.length < 13) return val

  // Découpage selon le masque standard
  // S AA MM JJ CCC OOO CC
  const match = val.match(/^(\d{1})(\d{2})(\d{2})([A-Z0-9]{2})(\d{3})(\d{3})(\d{2})$/)

  if (match) {
    return `${match[1]} ${match[2]} ${match[3]} ${match[4]} ${match[5]} ${match[6]} ${match[7]}`
  }

  return val
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount('#app')
